import { ILocaleConfig } from "@/config/locale.config";
import { SupportedLocale } from "@/enums/locale.enum";

// UAE-specific locale configuration
const uaeLocaleConfig: ILocaleConfig = {
  supportedLocales: [
    SupportedLocale.AR,
    SupportedLocale.EN,
    SupportedLocale.RU,
  ],
  defaultLocale: SupportedLocale.EN,
  languageTabs: [
    { key: SupportedLocale.AR, label: "AR" },
    { key: SupportedLocale.EN, label: "EN" },
    { key: SupportedLocale.RU, label: "RU" },
  ],
};

export default uaeLocaleConfig;
